export default __webpack_public_path__ + "static/media/aroma.777b4a28.jpg";